import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconIntegrations: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"integrations, frames, keyframes, interactions"} maskId="square-filled-radius-0-stroke-1-IconIntegrations"><path d="M17.207 12L9 20.207L0.792969 12L9 3.79297L17.207 12Z" fill="currentColor"/><path d="M23.207 12L15 20.207L12.625 17.832L18.457 12L12.625 6.16797L15 3.79297L23.207 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconIntegrations;
